import axios from 'axios'
import { imageUpload } from '@/api/requests/score'
import { uploadResp } from '@/model/score/score'

function base64ToFile(base64Data: string, filename: string) {
  const arr = base64Data.split(',')
  const mime = 'image/jpeg' // 获取文件的 MIME 类型
  const bstr = atob(arr[1]) // 解码 base64 字符串
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}
export async function uploadFile(
  base64Data: string,
  filename: string,
  cb: (value: boolean, data?: uploadResp) => void,
  loading: (value: boolean) => void
) {
  loading(true)
  const file = base64ToFile(base64Data, filename)
  const formData = new FormData()
  formData.append('file', file)
  formData.append('fileName', filename)
  formData.append('fileLifeEnum', 'FOREVER') // 如果有其他枚举值，可以调整
  formData.append('size', file.size + '')
  formData.append('duration', '60')
  formData.append('returnUrl', 'true')
  try {
    imageUpload(formData)
      .then((value) => {
        if (value.code === 1) {
          cb(true, value.data)
          console.log('文件上传成功:')
        } else {
          cb(false)
          console.error('文件上传失败:', value)
        }
      })
      .finally(() => {
        loading(false)
      })
  } catch (error) {
    cb(false)
    loading(false)
    console.error('文件上传失败:', error)
  }
}
